var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartUnfilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 63,
    viewBox: "0 0 62 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5453 29.2349L32.5667 48.7399L47.1944 29.2349C55.464 15.9839 36.5949 8.6697 30.8701 19.4823C18.9981 8.35132 8.39699 22.6621 14.5453 29.2349Z",
    stroke: "url(#paint0_radial_1639_2457)",
    strokeWidth: 3.40446
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8557 43.0743C27.7613 39.1861 18.7554 30.1911 17.0929 28.2773C14.6349 25.4477 15.9338 18.5 22.4256 19.0248C19.1189 20.937 16.5756 28.4239 32.8557 43.0743Z",
    fill: "url(#paint1_radial_1639_2457)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1639_2457",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.5061 22.8801) rotate(53.772) scale(31.2026 31.794)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E81092"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1639_2457",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.4072 25.7338) rotate(60.4975) scale(19.9656 14.1659)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E81092"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartUnfilled);
export default __webpack_public_path__ + "static/media/HeartUnfilled.258b299df7626421082b19e5961aa1c7.svg";
export { ForwardRef as ReactComponent };